import api from './interceptor'

export const getSMSTemplates = async () => {
    try{
        const response = await api.get(`sms/sms-templates`)
        console.log(response);
        return response.data
    }catch(e){
        console.log(e.message)
    }
}

export const getSMSBaseDates = async () => {
    try{
        const response = await api.get(`sms/sms-base`)
        return response.data
    }catch(e){
        console.log(e.message)
        // throw e
    }
}

export const addSMSBase = async (file) => {
    try{
        const formData = new FormData()
        formData.append('file', file)
        const response = await api.post(`sms/sms-base`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        console.log("success")
        return response
    }catch(e){
        console.log(e.message)
    }
}

export const sendSMS = async (data) => {
    try{
        console.log("data -> ",data)
        const response = await api.post(`sms/sms-queue`, data)
        return response
    }catch(e){
        console.log(e.message)
    }
}